export default {
  numero_cep: null,
  estaCarregando: false,
  objCep: {}
}
